import {colors} from 'js-libs/sweetcommons/styles';
import styled from 'styled-components';

export const StyledSidebarDIV = styled.div.attrs({
  className: 'col-md-3 col-xl-2 mb-4 mb-md-0',
})`
    -webkit-overflow-scrolling: touch;
    background-color: ${colors.lightBg};
}
`;
